"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var RESERVED_PROPS = ['children'];

var pickProps = function pickProps() {
  var propsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var shouldForwardProp = function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && (propsList.includes(prop) || RESERVED_PROPS.includes(prop));
  };

  return {
    shouldForwardProp: shouldForwardProp
  };
};

var _default = pickProps;
exports["default"] = _default;